import { K } from '../apiServiceI18n';

export const BASE_COLS = [
  { labelKey: K.LBL_NAME, key: 'name' },
  { labelKey: K.LBL_STATUS, key: 'status' },
  { labelKey: K.WORKFLOW_GROUP, key: 'workflowGroup' },
  { labelKey: K.WORKFLOW, key: 'workflowName' },
  { labelKey: K.API_SVC_COL_ADAPTER, key: 'adapter' },
  { labelKey: K.TOKEN, key: 'authorization' },
  { labelKey: K.CREATED_DATE, key: 'createdTs' },
  { labelKey: K.API_SVC_COL_LAST_EXECUTED, key: 'lastExecuted' },
  { labelKey: K.API_SVC_COL_VERSION, key: 'version' },
  { labelKey: K.LBL_ACTIONS, key: null },
];

export const GRID_ACCOUNT =
  'minmax(140px,1.4fr) 88px minmax(100px,1fr) minmax(120px,1.2fr) minmax(120px,1.2fr) minmax(130px,1.3fr) minmax(120px,1.2fr) minmax(150px,1.1fr) minmax(150px,1.1fr) minmax(56px,0.7fr) 56px';

export const GRID_SCOPED =
  'minmax(140px,1.4fr) 88px minmax(120px,1.2fr) minmax(120px,1.2fr) minmax(130px,1.3fr) minmax(120px,1.2fr) minmax(150px,1.1fr) minmax(150px,1.1fr) minmax(56px,0.7fr) 56px';

export function getTableColumns(showAccountCol) {
  if (!showAccountCol) return BASE_COLS;
  return [
    BASE_COLS[0],
    BASE_COLS[1],
    { labelKey: K.ACCOUNT, key: 'account' },
    ...BASE_COLS.slice(2),
  ];
}

export function getTableGrid(showAccountCol) {
  return {
    gridCols: showAccountCol ? GRID_ACCOUNT : GRID_SCOPED,
    minWidth: showAccountCol ? 1380 : 1280,
  };
}

/** Varied skeleton widths per column (includes Account column when present). */
export const SKELETON_WIDTHS = [
  '72%',
  '48px',
  '55%',
  '65%',
  '70%',
  '80%',
  '60%',
  '85%',
  '75%',
  '40px',
  '32px',
];
